export default __webpack_public_path__ + "static/harmonious-carousel-mobile-panel2-331a05c5f59ae3648a726dff880289c1036788fb6216bc4f4db262ae5a6d80b0.png";